<div class="viewport" *ngIf="useType">
    <div class="table-2" *ngIf="useType.labels.length; else noUsesMessage">
        <div class="column" *ngFor="let label of useType.labels">
            <div class="use-type-header"
                [ngClass]="{'light-red-box': label?.importValidationResult && !label?.importValidationResult.isNotEmptyLabel}">
                <label
                    [ngClass]="{'red-text': label?.importValidationResult && !label?.importValidationResult.isValid}">
                    {{label?.Label}}
                </label>

                <div class='icon-container'>

                    <div class="flags-icons-container">
                        <ziq-calibration-set-attributes-icons *ngIf="!hideAttributeButtons"
                            [attributesFlags]="getAttributesFlags(label)" class="flags-icons">
                        </ziq-calibration-set-attributes-icons>
                        <calibration-uses-label-attributes *ngIf="!hideAttributeButtons"
                            [identifiers]="getIdentifiers(label)" [attributePopupTitleDetails]="label?.Label"
                            [calibrationEntity]="label"></calibration-uses-label-attributes>

                    </div>

                    <select class="gridics-use-tag-select" [(ngModel)]="label.GridicsUseTagId"
                        [ngClass]="{'changed': label.isFieldChanged('GridicsUseTagId'), 'error': !getIsValidGridicsUseTag(label)}" [disabled]="readOnly"
                        (change)="handleGridicsUseTagIdManualChange(label); handleGridicsUseTagIdValueChange(label)">
                        <option [ngValue]="null"></option>
                        <option *ngFor="let tag of gridicsUseTags" [ngValue]="tag.Id">
                            {{tag.GridicsUse}}
                        </option>
                    </select>

                    <select [(ngModel)]='label.ClassId'
                        [ngClass]="{'changed': label.isFieldChanged('ClassId'), 'error': !getIsValidUseClass(label)}"
                        [disabled]="readOnly"
                        (change)="handleClassIdManualChange(label); handleClassIdValueChange(label)">
                        <option *ngFor="let useClass of useClassOptions" [ngValue]="useClass.Id">
                            {{useClass.Abbreviation}}</option>
                    </select>
                </div>

            </div>
            <div class="table-body">
                <div class="cell" *ngFor="let column of columns">
                    <ziq-uses-cell [use]="column.uses.get(label.Id)" [visibilityOptions]="visibilityOptions"
                        [currentTab]="currentTab" [useAllowances]="useAllowances"
                        [attributePopupTitleDetails]="column.calibrationSet.Name + ' - ' + label?.Label"
                        [hideAttributeButtons]="hideAttributeButtons" [readOnly]="readOnly"></ziq-uses-cell>
                </div>
            </div>
        </div>
    </div>
    <ng-template #noUsesMessage>
        <div class="message"> No Uses</div>
    </ng-template>
</div>
